module.exports = __webpack_public_path__ + "static/img/title.410aba2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/companies/immark/title.jpg
// module id = 395
// module chunks = 1